<button
    class="btn btn-primary more-info-btn"
    *ngIf="displayOptIn"
    [ngStyle]="{ 'background-color': promoOptinBtnBgClr, 'color': promoOptinBtnClr }"
    [disabled]="optInDisabled"
    (click)="optInClicked()">
    {{ optInButtonText }}
</button>
<span class="promoStatusError" *ngIf="displayError">{{ errorMessage }}</span>
